<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { FormDefDependenciesReadModel } from "@Alternatives/Forms/Domain/readmodels";
    import { DependentEntityInfo } from "@common/types";
    import { dynamicUiRoutes } from "@common/dynamicUiRoutes";

    @Component({
        props: {
            readModel: {
                type: Object,
                required: true,
                default: null
            }
        }
    })
    export default class FormDependenciesList extends Vue
    {
        get rm(): FormDefDependenciesReadModel { return this.$props.readModel as FormDefDependenciesReadModel; }

        get requestPages(): DependentEntityInfo[] { return this.rm.RequestPages ?? []; }

        url_EditRequestPagePage(e: DependentEntityInfo): string
        {
            return dynamicUiRoutes.Pages_EditRequestPagePage(this.$route, e.WorkspaceId, e.TchProjectId, Number.parseInt(e.Id));
        }

        url_ReportViewPage(e: DependentEntityInfo): string
        {
            return dynamicUiRoutes.Reports_ReportViewPage(this.$route, e.WorkspaceId, e.TchProjectId, e.Id);
        }
    }
</script>

<template>
    <div>

        <h4 v-if="!rm">
            <i class="fa fa-spinner fa-spin"></i> Checking dependencies...
        </h4>
        <div v-if="rm">
            <div class="card" v-if="requestPages.length > 0">
                <div class="card-header">
                    RequestPages ({{requestPages.length}})
                </div>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item" v-for="p in requestPages" :key="p.Id">
                        <a class="text-primary" target="_blank" v-sanitizedHref="url_EditRequestPagePage(p)">{{p.Name}}</a>
                    </li>
                </ul>
            </div>

            <div class="card mt-3" v-if="rm.Reports.length > 0">
                <div class="card-header">
                    Reports ({{rm.Reports.length}})
                </div>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item" v-for="r in rm.Reports" :key="r.Id">
                        <a class="text-primary" target="_blank" v-sanitizedHref="url_ReportViewPage(r)">{{r.Name}}</a>
                    </li>
                </ul>
            </div>

            <div class="card mt-3" v-if="rm.Notifications.length > 0">
                <div class="card-header">
                    Notifications ({{rm.Notifications.length}})
                </div>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item" v-for="n in rm.Notifications" :key="n.Id">
                        <span>{{n.Name}}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template> 